export enum DocumentName {
  REPLACEMENT_NOTICE = 'replacement-notice.pdf',
  AGENT_DISCLOSURES = 'agent-disclosures.pdf',
  INSURANCE_ILLUSTRATION = 'insurance-illustration.pdf',
  ARCHIVED_FNA = 'archived-fna.pdf',
  CONTRACT = 'contract.pdf',
  REASON_WHY_LETTER = 'reason-why-letter.pdf',
}
